var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"logo-site-img",class:{ 'logo-footer-fixed': _vm.forceDark },attrs:{"src":_vm.logoSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }